import { Box } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Form from "./Form";
import LoadingScreen from "./LoadingScreen";
import Table from "./Table";
import DetailQuota from "./DetailQuota";
import ButtonGroup from "./ButtonGroup";
import SharedComponent from "./SharedComponent";
import { useEffect } from "react";
import { getUserCountries, resetAllStates } from "./quotaCopySlice";

export default function QuotaCopySubmit() {
   const dispatch = useDispatch();
	const quotaCopy = useSelector((state) => state.quotaCopy);
	const { countries, quotaDetailsTable, detailQuotaTable } = quotaCopy;

   useEffect(() => {
      dispatch(resetAllStates())
      if (countries.length === 0) {
         dispatch(getUserCountries());
      }
   }, []);

	return (
		<Box sx={{ maxWidth: "100%" }}>
         <SharedComponent/>
			<LoadingScreen />
         {countries.length > 0 ? <Form /> : null}
			{quotaDetailsTable !== null && quotaDetailsTable.rows.length !== 0 ? <Table /> : null}
			{quotaDetailsTable !== null && quotaDetailsTable.rows.length !== 0 ? <ButtonGroup /> : null}
			{detailQuotaTable !== null && detailQuotaTable.rows.length !== 0 ? <DetailQuota /> : null}
		</Box>
	);
}
